import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dialog']

  connect() {
    this.element.dataset.drawerConnected = 'true'
  }

  open(event) {
    event?.preventDefault()
    if (!this.hasDialogTarget) return
    if (!this.dialogTarget.open) this.dialogTarget.showModal()
  }

  close(event) {
    event?.preventDefault()
    if (!this.hasDialogTarget) return
    if (this.dialogTarget.open) this.dialogTarget.close()
  }

  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  closeOnNavigation() {
    this.close()
  }

  snapClosed() {
    this.close()
  }
}
